import { FC } from 'react';

import { MdOutlineCampaign } from 'react-icons/md';

import { useTheme } from 'styled-components';
import { useReleaseNotes } from '~/modules/release-notes/providers/release-notes';
import { currentVersion } from '~/modules/release-notes/data';

import { Typography } from '~/common/components/Typography';

import { VersionButtonContainer } from './styles';

export const VersionButton: FC = () => {
  const theme = useTheme();
  const { openReleaseNotes } = useReleaseNotes();

  if (!currentVersion) {
    return null;
  }

  return (
    <VersionButtonContainer
      type="button"
      onClick={openReleaseNotes}
      title="Ver as novidades desta versão"
    >
      <MdOutlineCampaign size={14} color={theme.neutral[500]} />

      <Typography.Label size="x-small" color="neutral.500">
        {`v${currentVersion}`}
      </Typography.Label>
    </VersionButtonContainer>
  );
};
